/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * A single message of the comparison against the head position of the hiring department.
 */
export interface MercerDataValidationMessage {
  /**
   * The field of the position request the message belongs to.
   */
  field?: MercerDataValidationMessageFieldEnum;
  /**
   * Whether the message prevents the position request from being created or updated.
   */
  isBlocking?: boolean;
  /**
   * The message to display at the field.
   */
  message: string | null;
}
export enum MercerDataValidationMessageFieldEnum {
  PositionClass = 'PositionClass',
  CareerLevel = 'CareerLevel',
  CareerStream = 'CareerStream'
}
